import { useState } from "react";

export default function useWidgetReload() {
    const [reloadKey, setReloadKey] = useState(0);

    const reloadWidgets = () => {
        setReloadKey(prev => prev + 1);
    };

    return {
        reloadKey,
        reloadWidgets,
    };
}